export const openKlaviyoForm = (klaviyoFormId) => {
	if (typeof window !== "undefined") {
		window._klOnsite = window._klOnsite || [];
		window._klOnsite.push(["openForm", klaviyoFormId]);
	}
};
